export const BLANK_CONTACT_LOCATION_ROLES = { locationId: "", roles: [], isPrimary: false }
